// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1IVbb","info":"Note_info__33CKQ","note":"Note_note__3eR0q","actions":"Note_actions__2HTul"};